import React, { useContext, useEffect, useRef, useState } from 'react'
import dynamic from 'next/dynamic'

import { Container, SpacerBase } from '@/atoms/Grid'
import { Form } from '@/atoms'
import Modal from '@/molecules/Modal'
import { ModalContext } from '@contexts/Modal'

import { default as normalizeLocations } from '@models/Locations'

const StoreLocator = dynamic(() => import('@/molecules/StoreLocator'), {
  ssr: false,
  loading: () => <p>Caricamento...</p>,
})

const StoreLocatorForm = ({ data, formData }) => {
  const { handleModalChange } = useContext(ModalContext)
  const [state, setState] = useState({
    search: null,
    locations: [],
  })

  const handleSubmit = async (values, formResponse) => {
    const latLng = values.sort_by.split(',')
    const locations = normalizeLocations({
      locationSearched: {
        lat: latLng[0].split(':').pop(),
        lng: latLng[1].split(':').pop(),
      },
      locations: formResponse.body,
      banks: data.banks,
    })
    const nextState = {
      search: values.storeLocatorSearch,
      locations,
    }
    setState(nextState)
    handleModalChange(true, 'store-locator')
  }

  return (
    <>
      <Container>
        <div style={{ maxWidth: '706px', margin: '0 auto' }}>
          <Form
            {...formData}
            onSubmit={handleSubmit}
          />
        </div>
      </Container>
      <SpacerBase xs={4} />
      <Modal id='store-locator'>
        {state.search ? (
          <StoreLocator
            {...data}
            search={state.search}
            stores={state.locations}
          />
        ) : null}
      </Modal>
    </>
  )
}

export default StoreLocatorForm
